import $ from '../tools/Dom';

const onClick = e => {
    const node = $(e.triggerTarget);
    const data = node.data('event-link');

    if (typeof window.ga === 'function') {
        window.ga('send', {
            hitType: 'event',
            eventCategory: data.category,
            eventAction: data.action,
            eventLabel: data.label
        });
    }
};

const init = () => {
    $('[data-event-link]').on('click', onClick);
};

export default {
    init
};
